<template>
  <div>
    <dt
      class="font-medium text-gray-500 dark:text-gray-400 truncate"
      :class="small ? 'text-xs' : 'text-sm sm:text-md'"
    >
      {{ title }}
      <i
        v-if="hint"
        v-tooltip="hint"
        class="far fa-info-circle"
      />
    </dt>
    <dd
      class="
        flex
        justify-between
        items-end
        space-x-3
        font-semibold
        text-gray-900
        dark:text-gray-100
      "
      :class="small ? 'text-md mt-1' : 'text-xl mt-3'"
    >
      <premium-placeholder :disabled="requiresPremium === false">
        <slot
          v-if="!isLoading"
          name="value"
          v-bind="{ value, displayValue }"
        >
          <span class="font-mono whitespace-nowrap">{{
            displayValue
          }}</span>
        </slot>
        <loading-placeholder
          v-else-if="!small"
          :width="76"
          :height="20"
          class="h-5"
        >
          <rect
            x="0"
            y="0"
            rx="5"
            ry="5"
            width="76"
            height="20"
          />
        </loading-placeholder>
        <loading-placeholder
          v-else-if="small"
          :width="38"
          :height="14"
          class="h-5"
        >
          <rect
            x="0"
            y="0"
            rx="5"
            ry="5"
            width="38"
            height="14"
          />
        </loading-placeholder>
        <slot name="extra">
          <div
            v-if="shouldCompare && !isLoading"
            :class="{
              ' text-green-400 dark:text-green-500':
                percentChange > 0,
              ' text-red-400  dark:text-red-500':
                percentChange < 0,
            }"
            class="
              inline-flex
              flex-grow-0
              items-baseline
              md:mt-2
              lg:mt-0
              space-x-2
              text-sm
              font-medium
              rounded-full
            "
            :title="compareTo"
          >
            <i
              class="fas"
              :class="{
                'fa-long-arrow-up transform rotate-45': percentChange > 0,
                'fa-long-arrow-down transform -rotate-45': percentChange < 0,
              }"
            />
            <span class="hidden sm:inline">{{
              formatPercent(percentChange)
            }}</span>
          </div>
        </slot>
        <template #placeholder-content> 
          <div
            class="flex gap-3 items-center cursor-pointer"
            @click="eventBus.$emit('auth:showPremiumModal', 'metric widget')"
          >
            <premium-icon size="sm" />
          </div>
        </template>
        <template #placeholder-content-guest> 
          <div
            class="flex gap-3 items-center cursor-pointer"
            @click="eventBus.$emit('auth:signIn')"
          >
            <premium-icon size="sm" />
          </div>
        </template>
      </premium-placeholder>
    </dd>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { formatPercent } from "@/utils/filters";
import LoadingPlaceholder from "@/components/LoadingPlaceholder";
import PremiumPlaceholder from "./PremiumPlaceholder.vue";
import PremiumIcon from './PremiumIcon.vue';
import eventBus from "@/utils/event-bus";

export default defineComponent({
  name: "MetricWidget",
  components: { LoadingPlaceholder, PremiumPlaceholder, PremiumIcon },
  props: {
    "title": null,
    "value": null,
    "formatter": null,
    "formatterArgs": null,
    "compareTo": null,
    "isLoading": null,
    "hint": null,
    "small": null,
    "requiresPremium": {
      default: false,
      type: Boolean,
    }
  },

  setup() {
    return {
      eventBus,
      formatPercent,
    }
  },

  computed: {
    displayValue() {
      if (!this.formatter) {
        return this.value;
      }

      if (typeof this.formatter === "function") {
        return this.formatter(this.value);
      }

      return this.formatter(this.value, ...(this.formatterArgs || []));
    },
    shouldCompare() {
      return typeof this.compareTo !== "undefined";
    },
    percentChange() {
      if (!this.shouldCompare) {
        return;
      }

      return (this.value - this.compareTo) / this.compareTo;
    },
  },
});
</script>

<style scoped>
</style>
